export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_fragment_6.8149aee0.jpg";